export default {"src":"/_next/static/media/ic_place.6280e72d.svg","height":21,"width":18};